// extracted by mini-css-extract-plugin
export default {"container":"VideoCard_container__voHn0","thumbnailWrapper":"VideoCard_thumbnailWrapper__kvwU6","title":"VideoCard_title__0LiNN"};